import { defineComponent as Ne, watchEffect as Ee, ref as c, toRef as N, computed as m, watch as Le, h as y, Transition as $e, withDirectives as We, vShow as Ke } from "vue";
import { createValOptMap as He, patternMatched as E, filterOptions as qe, createTmOptions as Ge } from "./ghl-ui.es867.js";
import Je from "./ghl-ui.es1087.js";
import { warnOnce as ae } from "./ghl-ui.es853.js";
import Qe from "./ghl-ui.es854.js";
import de from "./ghl-ui.es855.js";
import re from "./ghl-ui.es712.js";
import { createTreeMate as Xe } from "./ghl-ui.es871.js";
import Ye from "./ghl-ui.es919.js";
import Ze from "./ghl-ui.es714.js";
import et from "./ghl-ui.es870.js";
import { useThemeClass as tt } from "./ghl-ui.es857.js";
import nt from "./ghl-ui.es713.js";
import lt from "./ghl-ui.es1088.js";
import it from "./ghl-ui.es873.js";
import ue from "./ghl-ui.es718.js";
import ot from "./ghl-ui.es1089.js";
import { getPreciseEventTarget as at } from "./ghl-ui.es875.js";
import { happensIn as se } from "./ghl-ui.es944.js";
import { markEventEffectPerformed as rt } from "./ghl-ui.es975.js";
import { call as g } from "./ghl-ui.es876.js";
import { useAdjustedTo as L } from "./ghl-ui.es877.js";
import ut from "./ghl-ui.es878.js";
import st from "./ghl-ui.es879.js";
import dt from "./ghl-ui.es880.js";
const ct = Object.assign(Object.assign({}, de.props), {
  to: L.propTo,
  bordered: {
    type: Boolean,
    default: void 0
  },
  clearable: Boolean,
  clearFilterAfterSelect: {
    type: Boolean,
    default: !0
  },
  options: {
    type: Array,
    default: () => []
  },
  defaultValue: {
    type: [String, Number, Array],
    default: null
  },
  keyboard: {
    type: Boolean,
    default: !0
  },
  value: [String, Number, Array],
  placeholder: String,
  menuProps: Object,
  multiple: Boolean,
  size: String,
  filterable: Boolean,
  disabled: {
    type: Boolean,
    default: void 0
  },
  remote: Boolean,
  loading: Boolean,
  filter: Function,
  placement: {
    type: String,
    default: "bottom-start"
  },
  widthMode: {
    type: String,
    default: "trigger"
  },
  tag: Boolean,
  onCreate: Function,
  fallbackOption: {
    type: [Function, Boolean],
    default: void 0
  },
  show: {
    type: Boolean,
    default: void 0
  },
  showArrow: {
    type: Boolean,
    default: !0
  },
  maxTagCount: [Number, String],
  ellipsisTagPopoverProps: Object,
  consistentMenuWidth: {
    type: Boolean,
    default: !0
  },
  virtualScroll: {
    type: Boolean,
    default: !0
  },
  labelField: {
    type: String,
    default: "label"
  },
  valueField: {
    type: String,
    default: "value"
  },
  childrenField: {
    type: String,
    default: "children"
  },
  renderLabel: Function,
  renderOption: Function,
  renderTag: Function,
  "onUpdate:value": [Function, Array],
  inputProps: Object,
  nodeProps: Function,
  ignoreComposition: {
    type: Boolean,
    default: !0
  },
  showOnFocus: Boolean,
  // for jsx
  onUpdateValue: [Function, Array],
  onBlur: [Function, Array],
  onClear: [Function, Array],
  onFocus: [Function, Array],
  onScroll: [Function, Array],
  onSearch: [Function, Array],
  onUpdateShow: [Function, Array],
  "onUpdate:show": [Function, Array],
  displayDirective: {
    type: String,
    default: "show"
  },
  resetMenuOnOptionsChange: {
    type: Boolean,
    default: !0
  },
  status: String,
  showCheckmark: {
    type: Boolean,
    default: !0
  },
  /** deprecated */
  onChange: [Function, Array],
  items: Array
}), zt = Ne({
  name: "Select",
  props: ct,
  setup(n) {
    process.env.NODE_ENV !== "production" && Ee(() => {
      n.items !== void 0 && ae("select", "`items` is deprecated, please use `options` instead."), n.onChange !== void 0 && ae("select", "`on-change` is deprecated, please use `on-update:value` instead.");
    });
    const {
      mergedClsPrefixRef: f,
      mergedBorderedRef: M,
      namespaceRef: h,
      inlineThemeDisabled: s
    } = Qe(n), $ = de("Select", "-select", Je, ot, n, f), z = c(n.defaultValue), ce = N(n, "value"), T = re(ce, z), C = c(!1), w = c(""), fe = m(() => {
      const {
        valueField: e,
        childrenField: t
      } = n, l = Ge(e, t);
      return Xe(ge.value, l);
    }), W = m(() => He(q.value, n.valueField, n.childrenField)), A = c(!1), v = re(N(n, "show"), A), d = c(null), K = c(null), R = c(null), {
      localeRef: he
    } = Ye("Select"), ve = m(() => {
      var e;
      return (e = n.placeholder) !== null && e !== void 0 ? e : he.value.placeholder;
    }), j = Ze(n, ["items", "options"]), B = [], p = c([]), O = c([]), _ = c(/* @__PURE__ */ new Map()), H = m(() => {
      const {
        fallbackOption: e
      } = n;
      if (e === void 0) {
        const {
          labelField: t,
          valueField: l
        } = n;
        return (r) => ({
          [t]: String(r),
          [l]: r
        });
      }
      return e === !1 ? !1 : (t) => Object.assign(e(t), {
        value: t
      });
    }), q = m(() => O.value.concat(p.value).concat(j.value)), me = m(() => {
      const {
        filter: e
      } = n;
      if (e)
        return e;
      const {
        labelField: t,
        valueField: l
      } = n;
      return (r, o) => {
        if (!o)
          return !1;
        const i = o[t];
        if (typeof i == "string")
          return E(r, i);
        const a = o[l];
        return typeof a == "string" ? E(r, a) : typeof a == "number" ? E(r, String(a)) : !1;
      };
    }), ge = m(() => {
      if (n.remote)
        return j.value;
      {
        const {
          value: e
        } = q, {
          value: t
        } = w;
        return !t.length || !n.filterable ? e : qe(e, me.value, t, n.childrenField);
      }
    });
    function U(e) {
      const t = n.remote, {
        value: l
      } = _, {
        value: r
      } = W, {
        value: o
      } = H, i = [];
      return e.forEach((a) => {
        if (r.has(a))
          i.push(r.get(a));
        else if (t && l.has(a))
          i.push(l.get(a));
        else if (o) {
          const u = o(a);
          u && i.push(u);
        }
      }), i;
    }
    const G = m(() => {
      if (n.multiple) {
        const {
          value: e
        } = T;
        return Array.isArray(e) ? U(e) : [];
      }
      return null;
    }), J = m(() => {
      const {
        value: e
      } = T;
      return !n.multiple && !Array.isArray(e) ? e === null ? null : U([e])[0] || null : null;
    }), V = et(n), {
      mergedSizeRef: pe,
      mergedDisabledRef: I,
      mergedStatusRef: be
    } = V;
    function k(e, t) {
      const {
        onChange: l,
        "onUpdate:value": r,
        onUpdateValue: o
      } = n, {
        nTriggerFormChange: i,
        nTriggerFormInput: a
      } = V;
      l && g(l, e, t), o && g(o, e, t), r && g(r, e, t), z.value = e, i(), a();
    }
    function Q(e) {
      const {
        onBlur: t
      } = n, {
        nTriggerFormBlur: l
      } = V;
      t && g(t, e), l();
    }
    function Oe() {
      const {
        onClear: e
      } = n;
      e && g(e);
    }
    function Fe(e) {
      const {
        onFocus: t,
        showOnFocus: l
      } = n, {
        nTriggerFormFocus: r
      } = V;
      t && g(t, e), r(), l && P();
    }
    function ye(e) {
      const {
        onSearch: t
      } = n;
      t && g(t, e);
    }
    function we(e) {
      const {
        onScroll: t
      } = n;
      t && g(t, e);
    }
    function X() {
      var e;
      const {
        remote: t,
        multiple: l
      } = n;
      if (t) {
        const {
          value: r
        } = _;
        if (l) {
          const {
            valueField: o
          } = n;
          (e = G.value) === null || e === void 0 || e.forEach((i) => {
            r.set(i[o], i);
          });
        } else {
          const o = J.value;
          o && r.set(o[n.valueField], o);
        }
      }
    }
    function Y(e) {
      const {
        onUpdateShow: t,
        "onUpdate:show": l
      } = n;
      t && g(t, e), l && g(l, e), A.value = e;
    }
    function P() {
      I.value || (Y(!0), A.value = !0, n.filterable && ie());
    }
    function b() {
      Y(!1);
    }
    function Z() {
      w.value = "", O.value = B;
    }
    const D = c(!1);
    function Se() {
      n.filterable && (D.value = !0);
    }
    function Me() {
      n.filterable && (D.value = !1, v.value || Z());
    }
    function Te() {
      I.value || (v.value ? n.filterable ? ie() : b() : P());
    }
    function Ce(e) {
      var t, l;
      !((l = (t = R.value) === null || t === void 0 ? void 0 : t.selfRef) === null || l === void 0) && l.contains(e.relatedTarget) || (C.value = !1, Q(e), b());
    }
    function Re(e) {
      Fe(e), C.value = !0;
    }
    function Be(e) {
      C.value = !0;
    }
    function Pe(e) {
      var t;
      !((t = d.value) === null || t === void 0) && t.$el.contains(e.relatedTarget) || (C.value = !1, Q(e), b());
    }
    function Ae() {
      var e;
      (e = d.value) === null || e === void 0 || e.focus(), b();
    }
    function _e(e) {
      var t;
      v.value && (!((t = d.value) === null || t === void 0) && t.$el.contains(at(e)) || b());
    }
    function Ve(e) {
      if (!Array.isArray(e))
        return [];
      if (H.value)
        return Array.from(e);
      {
        const {
          remote: t
        } = n, {
          value: l
        } = W;
        if (t) {
          const {
            value: r
          } = _;
          return e.filter((o) => l.has(o) || r.has(o));
        } else
          return e.filter((r) => l.has(r));
      }
    }
    function ee(e) {
      x(e.rawNode);
    }
    function x(e) {
      if (I.value)
        return;
      const {
        tag: t,
        remote: l,
        clearFilterAfterSelect: r,
        valueField: o
      } = n;
      if (t && !l) {
        const {
          value: i
        } = O, a = i[0] || null;
        if (a) {
          const u = p.value;
          u.length ? u.push(a) : p.value = [a], O.value = B;
        }
      }
      if (l && _.value.set(e[o], e), n.multiple) {
        const i = Ve(T.value), a = i.findIndex((u) => u === e[o]);
        if (~a) {
          if (i.splice(a, 1), t && !l) {
            const u = te(e[o]);
            ~u && (p.value.splice(u, 1), r && (w.value = ""));
          }
        } else
          i.push(e[o]), r && (w.value = "");
        k(i, U(i));
      } else {
        if (t && !l) {
          const i = te(e[o]);
          ~i ? p.value = [p.value[i]] : p.value = B;
        }
        le(), b(), k(e[o], e);
      }
    }
    function te(e) {
      return p.value.findIndex((l) => l[n.valueField] === e);
    }
    function Ie(e) {
      v.value || P();
      const {
        value: t
      } = e.target;
      w.value = t;
      const {
        tag: l,
        remote: r
      } = n;
      if (ye(t), l && !r) {
        if (!t) {
          O.value = B;
          return;
        }
        const {
          onCreate: o
        } = n, i = o ? o(t) : {
          [n.labelField]: t,
          [n.valueField]: t
        }, {
          valueField: a,
          labelField: u
        } = n;
        j.value.some((F) => F[a] === i[a] || F[u] === i[u]) || p.value.some((F) => F[a] === i[a] || F[u] === i[u]) ? O.value = B : O.value = [i];
      }
    }
    function ke(e) {
      e.stopPropagation();
      const {
        multiple: t
      } = n;
      !t && n.filterable && b(), Oe(), t ? k([], []) : k(null, null);
    }
    function De(e) {
      !se(e, "action") && !se(e, "empty") && e.preventDefault();
    }
    function xe(e) {
      we(e);
    }
    function ne(e) {
      var t, l, r, o, i;
      if (!n.keyboard) {
        e.preventDefault();
        return;
      }
      switch (e.key) {
        case " ":
          if (n.filterable)
            break;
          e.preventDefault();
        case "Enter":
          if (!(!((t = d.value) === null || t === void 0) && t.isComposing)) {
            if (v.value) {
              const a = (l = R.value) === null || l === void 0 ? void 0 : l.getPendingTmNode();
              a ? ee(a) : n.filterable || (b(), le());
            } else if (P(), n.tag && D.value) {
              const a = O.value[0];
              if (a) {
                const u = a[n.valueField], {
                  value: F
                } = T;
                n.multiple && Array.isArray(F) && F.some((Ue) => Ue === u) || x(a);
              }
            }
          }
          e.preventDefault();
          break;
        case "ArrowUp":
          if (e.preventDefault(), n.loading)
            return;
          v.value && ((r = R.value) === null || r === void 0 || r.prev());
          break;
        case "ArrowDown":
          if (e.preventDefault(), n.loading)
            return;
          v.value ? (o = R.value) === null || o === void 0 || o.next() : P();
          break;
        case "Escape":
          v.value && (rt(e), b()), (i = d.value) === null || i === void 0 || i.focus();
          break;
      }
    }
    function le() {
      var e;
      (e = d.value) === null || e === void 0 || e.focus();
    }
    function ie() {
      var e;
      (e = d.value) === null || e === void 0 || e.focusInput();
    }
    function ze() {
      var e;
      v.value && ((e = K.value) === null || e === void 0 || e.syncPosition());
    }
    X(), Le(N(n, "options"), X);
    const je = {
      focus: () => {
        var e;
        (e = d.value) === null || e === void 0 || e.focus();
      },
      focusInput: () => {
        var e;
        (e = d.value) === null || e === void 0 || e.focusInput();
      },
      blur: () => {
        var e;
        (e = d.value) === null || e === void 0 || e.blur();
      },
      blurInput: () => {
        var e;
        (e = d.value) === null || e === void 0 || e.blurInput();
      }
    }, oe = m(() => {
      const {
        self: {
          menuBoxShadow: e
        }
      } = $.value;
      return {
        "--n-menu-box-shadow": e
      };
    }), S = s ? tt("select", void 0, oe, n) : void 0;
    return Object.assign(Object.assign({}, je), {
      mergedStatus: be,
      mergedClsPrefix: f,
      mergedBordered: M,
      namespace: h,
      treeMate: fe,
      isMounted: nt(),
      triggerRef: d,
      menuRef: R,
      pattern: w,
      uncontrolledShow: A,
      mergedShow: v,
      adjustedTo: L(n),
      uncontrolledValue: z,
      mergedValue: T,
      followerRef: K,
      localizedPlaceholder: ve,
      selectedOption: J,
      selectedOptions: G,
      mergedSize: pe,
      mergedDisabled: I,
      focused: C,
      activeWithoutMenuOpen: D,
      inlineThemeDisabled: s,
      onTriggerInputFocus: Se,
      onTriggerInputBlur: Me,
      handleTriggerOrMenuResize: ze,
      handleMenuFocus: Be,
      handleMenuBlur: Pe,
      handleMenuTabOut: Ae,
      handleTriggerClick: Te,
      handleToggle: ee,
      handleDeleteOption: x,
      handlePatternInput: Ie,
      handleClear: ke,
      handleTriggerBlur: Ce,
      handleTriggerFocus: Re,
      handleKeydown: ne,
      handleMenuAfterLeave: Z,
      handleMenuClickOutside: _e,
      handleMenuScroll: xe,
      handleMenuKeydown: ne,
      handleMenuMousedown: De,
      mergedTheme: $,
      cssVars: s ? void 0 : oe,
      themeClass: S == null ? void 0 : S.themeClass,
      onRender: S == null ? void 0 : S.onRender
    });
  },
  render() {
    return y("div", {
      class: `${this.mergedClsPrefix}-select`
    }, y(ut, null, {
      default: () => [y(st, null, {
        default: () => y(lt, {
          ref: "triggerRef",
          inlineThemeDisabled: this.inlineThemeDisabled,
          status: this.mergedStatus,
          inputProps: this.inputProps,
          clsPrefix: this.mergedClsPrefix,
          showArrow: this.showArrow,
          maxTagCount: this.maxTagCount,
          ellipsisTagPopoverProps: this.ellipsisTagPopoverProps,
          bordered: this.mergedBordered,
          active: this.activeWithoutMenuOpen || this.mergedShow,
          pattern: this.pattern,
          placeholder: this.localizedPlaceholder,
          selectedOption: this.selectedOption,
          selectedOptions: this.selectedOptions,
          multiple: this.multiple,
          renderTag: this.renderTag,
          renderLabel: this.renderLabel,
          filterable: this.filterable,
          clearable: this.clearable,
          disabled: this.mergedDisabled,
          size: this.mergedSize,
          theme: this.mergedTheme.peers.InternalSelection,
          labelField: this.labelField,
          valueField: this.valueField,
          themeOverrides: this.mergedTheme.peerOverrides.InternalSelection,
          loading: this.loading,
          focused: this.focused,
          onClick: this.handleTriggerClick,
          onDeleteOption: this.handleDeleteOption,
          onPatternInput: this.handlePatternInput,
          onClear: this.handleClear,
          onBlur: this.handleTriggerBlur,
          onFocus: this.handleTriggerFocus,
          onKeydown: this.handleKeydown,
          onPatternBlur: this.onTriggerInputBlur,
          onPatternFocus: this.onTriggerInputFocus,
          onResize: this.handleTriggerOrMenuResize,
          ignoreComposition: this.ignoreComposition
        }, {
          arrow: () => {
            var n, f;
            return [(f = (n = this.$slots).arrow) === null || f === void 0 ? void 0 : f.call(n)];
          }
        })
      }), y(dt, {
        ref: "followerRef",
        show: this.mergedShow,
        to: this.adjustedTo,
        teleportDisabled: this.adjustedTo === L.tdkey,
        containerClass: this.namespace,
        width: this.consistentMenuWidth ? "target" : void 0,
        minWidth: "target",
        placement: this.placement
      }, {
        default: () => y($e, {
          name: "fade-in-scale-up-transition",
          appear: this.isMounted,
          onAfterLeave: this.handleMenuAfterLeave
        }, {
          default: () => {
            var n, f, M;
            return this.mergedShow || this.displayDirective === "show" ? ((n = this.onRender) === null || n === void 0 || n.call(this), We(y(it, Object.assign({}, this.menuProps, {
              ref: "menuRef",
              onResize: this.handleTriggerOrMenuResize,
              inlineThemeDisabled: this.inlineThemeDisabled,
              virtualScroll: this.consistentMenuWidth && this.virtualScroll,
              class: [`${this.mergedClsPrefix}-select-menu`, this.themeClass, (f = this.menuProps) === null || f === void 0 ? void 0 : f.class],
              clsPrefix: this.mergedClsPrefix,
              focusable: !0,
              labelField: this.labelField,
              valueField: this.valueField,
              autoPending: !0,
              nodeProps: this.nodeProps,
              theme: this.mergedTheme.peers.InternalSelectMenu,
              themeOverrides: this.mergedTheme.peerOverrides.InternalSelectMenu,
              treeMate: this.treeMate,
              multiple: this.multiple,
              size: "medium",
              renderOption: this.renderOption,
              renderLabel: this.renderLabel,
              value: this.mergedValue,
              style: [(M = this.menuProps) === null || M === void 0 ? void 0 : M.style, this.cssVars],
              onToggle: this.handleToggle,
              onScroll: this.handleMenuScroll,
              onFocus: this.handleMenuFocus,
              onBlur: this.handleMenuBlur,
              onKeydown: this.handleMenuKeydown,
              onTabOut: this.handleMenuTabOut,
              onMousedown: this.handleMenuMousedown,
              show: this.mergedShow,
              showCheckmark: this.showCheckmark,
              resetMenuOnOptionsChange: this.resetMenuOnOptionsChange
            }), {
              empty: () => {
                var h, s;
                return [(s = (h = this.$slots).empty) === null || s === void 0 ? void 0 : s.call(h)];
              },
              header: () => {
                var h, s;
                return [(s = (h = this.$slots).header) === null || s === void 0 ? void 0 : s.call(h)];
              },
              action: () => {
                var h, s;
                return [(s = (h = this.$slots).action) === null || s === void 0 ? void 0 : s.call(h)];
              }
            }), this.displayDirective === "show" ? [[Ke, this.mergedShow], [ue, this.handleMenuClickOutside, void 0, {
              capture: !0
            }]] : [[ue, this.handleMenuClickOutside, void 0, {
              capture: !0
            }]])) : null;
          }
        })
      })]
    }));
  }
});
export {
  zt as default,
  ct as selectProps
};
